import React, {Component, createRef} from "react";
import FJResourceCommon from 'fj-components/FJResourceView'
import FJImage from "fj-components/FJImage";
import styles from './FJresourcesElementCommon.module.less';
import NoEffectIcon from '../../../icon/no_effect.svg'
import InlineSVG from "react-inlinesvg";

class FJElementAnimationCommon extends Component {

  constructor(props) {
    super(props);
    this.state = {
      thumbnailStatus: 'error'
    };
    this._resourceCommon = createRef();
  }

  /**
   * @description 设置缩略图的加载状态
   * @param status
   * @private
   */
  _setImgLoadStatus = (status) => {
    this.setState({
      thumbnailStatus: status
    });
  };

  _onClick = () => {
    let {onClick, id, isChoose} = this.props;
    if (!isChoose) {
      onClick(id);
    }
  };

  render() {
    let {
      width,
      height,
      marginRight,
      marginBottom,
      isChoose,
      thumbnail,
      hasName, // 是否显示名称
      name,
      addIconToolTip,
      classes,
      allTooltip,
      toggleTooltip,
      oneTooltip,
    } = this.props;

    return (
      <FJResourceCommon width={width}
                        height={height}
                        marginRight={marginRight}
                        marginBottom={marginBottom}
                        ref={this._resourceCommon}
                        hasAddBtn={false}
                        isCanShowHover
                        isChoose={isChoose}
                        onClick={this._onClick}
                        hasName={hasName}
                        name={name}
                        fileText={name}
                        addIconToolTip={addIconToolTip}
                        classes={classes}
                        allTooltip={allTooltip}
                        toggleTooltip={toggleTooltip}
                        oneTooltip={oneTooltip}
                        className={styles.copy_outer_box}
      >
        {
          thumbnail ?
            <FJImage url={thumbnail} setImgLoadStatus={this._setImgLoadStatus} refreshClassName={classes.refresh}/>
            : <InlineSVG src={NoEffectIcon}/>
        }
      </FJResourceCommon>
    )
  }

}


export default FJElementAnimationCommon;